import React, { Component } from 'react';
import { CleanLlegendaSvg } from './LlegendaFooterIconsElement';

export class NetejaLlegendaIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isButtonHovered: false
    };
  }

  render = () => {
    return (
      <CleanLlegendaSvg
        innerWidth={this.props.windowWidth}
        isHover={this.state.isButtonHovered}
        fontSizeEnabled={this.props.isFontSizeEnabled}
        onMouseEnter={() => this.setState({ isButtonHovered: true })}
        onMouseLeave={() => this.setState({ isButtonHovered: false })}>
        <path
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          d="M100,0h312c55.2,0.1,99.9,44.8,100,100v312c-0.1,55.2-44.8,99.9-100,100H100C44.8,511.9,0.1,467.2,0,412V100  C0.1,44.8,44.8,0.1,100,0z M141.7,443.1c-8.5,0-15.8-3-21.9-9.1c-6.1-6.1-9.1-13.4-9.1-21.9V117.5H89.5v-31h97.2V71h136.5v15.5h97.2  v31h-21.2v294.6c0,8.3-3.1,15.5-9.3,21.7c-6.2,6.2-13.4,9.3-21.7,9.3H141.7z M368.1,117.5H141.7v294.6h226.4V117.5z M196.5,367.7h31  V161.4h-31V367.7z M282.3,367.7h31V161.4h-31V367.7z M141.7,117.5v294.6V117.5z"
        />
      </CleanLlegendaSvg>
    );
  };
}
